import React, { Component } from "react";
import { Select } from "antd";
import axios from "axios";
import debounce from "lodash.debounce";

const { Option } = Select;

class SelectUbicacionesProyectoItem extends Component {
  constructor(props) {
    super(props);
    this.state = {
      opciones: [],
      cargando: false,
      texto: "",
    };

    this.buscarUbicaciones = debounce(this.buscarUbicaciones.bind(this), 300);
  }

  componentDidMount() {
    if (!this.props.opciones && this.props.proyectoId) {
      this.buscarUbicaciones("", true);
      if (this.props.value) {
        this.resolverPorId(this.props.value);
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.opciones) return;

    if (prevProps.proyectoId !== this.props.proyectoId) {
      if (this.props.proyectoId) {
        this.setState({ opciones: [], texto: "" });
        this.buscarUbicaciones("", true);
        if (this.props.value) {
          this.resolverPorId(this.props.value);
        }
      } else {
        this.setState({ opciones: [] });
      }
      return;
    }

    if (prevProps.value !== this.props.value && this.props.value) {
      const encontrada = this.state.opciones.find(
        (ubicacion) => ubicacion._id.toString() === this.props.value.toString()
      );
      if (!encontrada) {
        this.resolverPorId(this.props.value);
      }
    }
  }

  componentWillUnmount() {
    if (this.buscarUbicaciones && this.buscarUbicaciones.cancel) {
      this.buscarUbicaciones.cancel();
    }
  }

  async buscarUbicaciones(texto, primerCarga = false, append = false) {
    if (!this.props.proyectoId) return;
    this.setState({ cargando: true });
    try {
      const res = await axios.post(
        "ubicacionProyecto/selectUbicacionesProyecto",
        {
          empresaId: this.props.empresaId,
          proyectoId: this.props.proyectoId,
          estado: 1,
          query: append ? this.state.texto : texto,
          skip: append ? this.state.opciones.length : 0,
        },
        { headers: this.props.headersToken }
      );

      this.setState((prev) => ({
        opciones:
          res.data.success === 2
            ? append
              ? [...prev.opciones, ...res.data.ubicaciones]
              : res.data.ubicaciones
            : append
            ? prev.opciones
            : [],
        texto: append ? prev.texto : texto,
      }));
    } catch (error) {
      console.error("Error al buscar ubicaciones:", error);
      if (!append) this.setState({ opciones: [] });
    } finally {
      this.setState({ cargando: false });
    }
  }

  async resolverPorId(id) {
    if (!id || !this.props.proyectoId) return;
    try {
      const res = await axios.post(
        "ubicacionProyecto/selectUbicacionesProyecto",
        {
          empresaId: this.props.empresaId,
          proyectoId: this.props.proyectoId,
          id,
        },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2 && res.data.ubicaciones.length) {
        this.setState((prev) => {
          const yaExiste = prev.opciones.some(
            (ubicacion) => ubicacion._id.toString() === id.toString()
          );
          if (yaExiste) return null;
          return { opciones: [...res.data.ubicaciones, ...prev.opciones] };
        });
      }
    } catch (error) {
      console.error("Error al resolver ubicación por id:", error);
    }
  }

  render() {
    const { proyectoId, empresaId, headersToken, width, style, placeholder, opciones, ...restProps } = this.props;
    const modoLista = !!opciones;
    const cargando = modoLista ? false : this.state.cargando;
    const listaOpciones = modoLista ? opciones : this.state.opciones;

    const propsBusqueda = modoLista
      ? { optionFilterProp: "children" }
      : {
          filterOption: false,
          onSearch: (texto) => this.buscarUbicaciones(texto, false, false),
          onPopupScroll: (e) => {
            const { target } = e;
            if (target.scrollTop + target.offsetHeight >= target.scrollHeight - 4) {
              this.buscarUbicaciones(this.state.texto, false, true);
            }
          },
        };

    return (
      <Select
        allowClear
        showSearch
        loading={cargando}
        disabled={!proyectoId}
        placeholder={proyectoId ? (placeholder || "Ubicación") : "Selecciona primero el almacén"}
        style={{ width: width || "100%", ...style }}
        notFoundContent={cargando ? "Buscando ubicaciones..." : "Sin ubicaciones activas"}
        {...propsBusqueda}
        {...restProps}
      >
        {listaOpciones.map((ubicacion) => (
          <Option key={ubicacion._id} value={ubicacion._id}>
            {ubicacion.nombre}
          </Option>
        ))}
      </Select>
    );
  }
}

export default SelectUbicacionesProyectoItem;
